export default __webpack_public_path__ + "static/RelicHD_CFNW-31fb823fec8350e1c78fdd6b5b2329ec.jpg";